import type { Address } from "~/types/addressTypes.ts";

import CountryDisplay from "./CountryDisplay";

type Props = Address

const AddressDisplay = ({ city, countryId, houseNumber, street, zipCode }: Props) => {
	return <div>
				<span>
					{street} {houseNumber}
				</span>
		<br />
		{zipCode} {city}
		<br />
		<span>{countryId && <CountryDisplay id={countryId} />}</span>
	</div>;
};

export default AddressDisplay;